import { __extends, __assign } from 'tslib';
import * as React from 'react';
import { classNames, validatePropType } from 'uitk-react-utils';
import { UitkImageFits, UitkRoundcorners } from './types.esm.js';
import styles from './uitk-images.css';

var getClassNameList = classNames.bind(styles);
var UitkFigureAspectRatioType;
(function (UitkFigureAspectRatioType) {
    UitkFigureAspectRatioType["R1_1"] = "ratio-1-1";
    UitkFigureAspectRatioType["R4_3"] = "ratio-4-3";
    UitkFigureAspectRatioType["R3_2"] = "ratio-3-2";
    UitkFigureAspectRatioType["R16_9"] = "ratio-16-9";
    UitkFigureAspectRatioType["R21_9"] = "ratio-21-9";
    UitkFigureAspectRatioType["R3_4"] = "ratio-3-4";
    UitkFigureAspectRatioType["R4_1"] = "ratio-4-1";
})(UitkFigureAspectRatioType || (UitkFigureAspectRatioType = {}));
var UitkFigure = /** @class */ (function (_super) {
    __extends(UitkFigure, _super);
    function UitkFigure() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkFigure.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, children = _b.children, ratio = _b.ratio, src = _b.src, roundcorner = _b.roundcorner, imageFit = _b.imageFit, additionalProps = _b.additionalProps, style = _b.style;
        var Tag = src ? 'div' : 'figure';
        var handleRoundcornerClassArray = function (classArr, propArr, baseClass) {
            propArr.forEach(function (arrayValue) {
                return classArr.push("".concat(baseClass, "-").concat(UitkRoundcorners.get(arrayValue)));
            });
        };
        var roundcornerClass = function (prop) {
            var roundcornerBaseClass = 'uitk-image-roundcorner';
            var propType = typeof prop;
            var classArr = [];
            var propIsArray = Array.isArray(prop);
            if (propType === 'boolean') {
                // Prop type is boolean
                classArr.push("".concat(roundcornerBaseClass, "-all"));
            }
            else if (propIsArray) {
                // Prop type is array
                handleRoundcornerClassArray(classArr, prop, roundcornerBaseClass);
            }
            else {
                // Prop type is object
                var object_1 = prop;
                Object.getOwnPropertyNames(object_1).forEach(function (breakpointKey) {
                    var breakRoundcornerBaseClass = "".concat(roundcornerBaseClass, "-").concat(breakpointKey);
                    if (Array.isArray(object_1[breakpointKey])) {
                        handleRoundcornerClassArray(classArr, object_1[breakpointKey], breakRoundcornerBaseClass);
                    }
                    else {
                        // UitkRoundcornerBreakSetting type
                        var cornerObject_1 = object_1[breakpointKey];
                        Object.getOwnPropertyNames(cornerObject_1).forEach(function (cornerKey) {
                            if (cornerObject_1[cornerKey] === 'set') {
                                classArr.push("".concat(breakRoundcornerBaseClass, "-").concat(UitkRoundcorners.get(cornerKey)));
                            }
                            else if (cornerObject_1[cornerKey] === 'unset')
                                classArr.push("".concat(breakRoundcornerBaseClass, "-").concat(UitkRoundcorners.get(cornerKey), "-unset"));
                        });
                    }
                });
            }
            return classArr;
        };
        var classList = getClassNameList('uitk-image', className, roundcorner && roundcornerClass(roundcorner), imageFit && "uitk-image-".concat(UitkImageFits.get(imageFit)), (_a = {},
            _a["uitk-image-".concat(ratio, " uitk-image-ratio")] = validatePropType(ratio, UitkFigureAspectRatioType),
            _a["uitk-image-ratio-2-1 uitk-image-ratio"] = !ratio,
            _a['uitk-image-background'] = src,
            _a));
        var cssStyle = {};
        if (style) {
            cssStyle = style;
        }
        else if (src) {
            cssStyle = { backgroundImage: "url(\"".concat(src, "\")") };
        }
        var newProps = __assign({ className: classList, style: cssStyle }, additionalProps);
        return React.createElement(Tag, __assign({}, newProps), children);
    };
    UitkFigure.displayName = 'UitkFigure';
    UitkFigure.AspectRatio = UitkFigureAspectRatioType;
    return UitkFigure;
}(React.Component));

export { UitkFigure, UitkFigureAspectRatioType };
